import {
  DATE_TIME_SHORT_FORMAT,
  getDateFromSeconds,
  getDateInFormat
} from "@/helpers/date.helpers"

import type { FiltersResourceResponse } from "@/api/common.types"
import type { ScopesResponse } from "@/api/useScopes.types"

export const getScopesData = (response: ScopesResponse) => {
  const { data = [], metadata } = response || {}

  return {
    metadata,
    data: data.map(({ createdAt, ...scope }) => ({
      key: scope.id,
      createdAt: Number.isInteger(createdAt)
        ? getDateInFormat(getDateFromSeconds(createdAt), DATE_TIME_SHORT_FORMAT)
        : "",
      ...scope
    }))
  }
}

export const getOptions = (response: FiltersResourceResponse) => {
  return {
    data: (response?.data?.resources || []).reduce(
      (acc, { name, fields }) => {
        acc.fields[name] = fields.map((field) => ({
          label: field,
          value: field
        }))

        acc.resources.push({
          label: name,
          value: name
        })

        return acc
      },
      {
        resources: [] as { label: string; value: string }[],
        fields: {} as Record<string, { label: string; value: string }[]>
      }
    )
  }
}

type ResourcesOptions = {
  resources: { label: string; value: string }[]
  fields: Record<string, { label: string; value: string }[]>
}

export const withoutResource = (
  options: ResourcesOptions,
  resource: string
): ResourcesOptions => ({
  resources: options.resources.filter(({ value }) => value !== resource),
  fields: Object.fromEntries(
    Object.entries(options.fields).filter(([name]) => name !== resource)
  )
})
